import { useContext } from 'react';
import WebSocketContext from '../../context/WebSocketContext';
import { useDispatch } from 'react-redux';
import { setIsFileProcessing } from '../../store/slices/fileProcessingSlice';

const useWebSocketContext = () => {
  const context = useContext(WebSocketContext);
  const dispatch = useDispatch();

  if (!context) {
    throw new Error('useWebSocketContext must be used within a WebSocketProvider');
  }

  // Destructure isConnected from the context
  const { sendToWs, sendBinaryToWs, isConnected } = context;

  const handleMessage = (event: MessageEvent) => {
    const data = JSON.parse(event.data as string);

    if (data.chunk && typeof data.chunk === 'string' && data.chunk.startsWith('^')) {
      dispatch(setIsFileProcessing(false));
      // Here you can handle the PDF file name, if needed
      // e.g., extracting the filename from the chunk, etc.
    }

    // Handle other messages based on your application logic
    // ...
  };

  // Return isConnected so other hooks can use it
  return {
    sendToWs,
    sendBinaryToWs,
    handleMessage,
    isConnected,
  };
};

export default useWebSocketContext;